import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Vuelidate from 'vuelidate'
import vueDebounce from 'vue-debounce'
import Notifications from 'vue-notification'


Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');

Vue.use(Vuelidate);
Vue.use(Notifications);
Vue.use(vueDebounce, {
  listenTo: 'input'
});
